module.exports = __webpack_public_path__ + "static/media/safety.9e94fa44.png";